import { render, staticRenderFns } from "./AssignLicense.vue?vue&type=template&id=5d8b53f8&"
import script from "../../scripts/overlay/AssignLicense.js?vue&type=script&lang=js&"
export * from "../../scripts/overlay/AssignLicense.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports